import {
    ActivityRecord,
} from 'app/Apps/RelationshipsManagement/ActivityRecords/activityRecords.types'
import ActivityRecordForm from 'app/Apps/RelationshipsManagement/ActivityRecords/ActivityRecordForm'

export default function ActivityRecordDemoOverview({
    data, onSuccess, onCancel,
}: {
    data: ActivityRecord,
    onSuccess: () => void,
    onCancel: () => void,
}) {
    return (
        <ActivityRecordForm
            data={data as ActivityRecord}
            onSuccess={onSuccess}
            onCancel={onCancel}
            disabled
        />
    )
}
